export const $ = (sel: string, root?: Document | Element): Element | null =>
  (root ?? document).querySelector(sel);

export const $$ = (sel: string, root?: Document | Element): Element[] =>
  Array.from((root ?? document).querySelectorAll(sel));

export function setText(sel: string, text: string): void {
  const el = $(sel);
  if (el) el.textContent = text ?? '';
}

export function escapeHtml(s: string | undefined): string {
  if (!s) return '';
  const div = document.createElement('div');
  div.textContent = s;
  return div.innerHTML;
}
